import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ArrowLeft, Plus, X } from 'react-bootstrap-icons';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import '../styles/commonStyles.css'
import CardTemplate from '../components/CardTemplate';
import { toast, ToastContainer } from 'react-toastify';
import Api from '../services/request-service';
import { API_URL } from '../services/api_url';
import { useNavigate } from 'react-router';
import Loader from '../components/Loader';

function AddRewardPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: '',
    quantity: '',
    fancoins: '',
    image: null,
    is_rare: true,
    is_core: false
  });
  const [focusedFields, setFocusedFields] = useState({});
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    
    if (name === 'is_rare' && checked) {
      setFormData({
        ...formData,
        is_rare: true,
        is_core: false
      });
    } else if (name === 'is_core' && checked) {
      setFormData({
        ...formData,
        is_rare: false,
        is_core: true
      });
    } else {
      setFormData({
        ...formData,
        [name]: checked
      });
    }
  };

  const handleImageUpload = (e) => {
    if (e.target.files && e.target.files[0]) {
      if (e.target.files && e.target.files[0]) {
        const maxSize = 5 * 1024 * 1024; // 5MB in bytes
        let file = e.target.files[0];
        if (file.size > maxSize) {
          toast.warning("File size should not exceed 5MB.");
          e.target.value = ""; // Reset the input
          return;
        }
        setFormData({
          ...formData,
          image: e.target.files[0]
        });
      }
    }
  };

  const addReward = async (formData) => {
    try {
      setLoading(true);
      const response = await Api.post(API_URL.ADD_REWARD, formData, true, true);
      if (response.status === 201) {
        toast.success("Reward added successfully", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
        });
        setTimeout(() => {
          setFormData({
            title: '',
            quantity: '',
            fancoins: '',
            image: null,
            is_rare: true,
            is_core: false
          });
          navigate("/");
        }, 4000);
      }
      else {
        throw new Error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    }
    finally {
      setLoading(false);
    }
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    const ApiFormData = new FormData();
    ApiFormData.append('title', formData.title);
    if (!formData.is_core) {
      ApiFormData.append('quantity', formData.quantity);
    }
    ApiFormData.append('fancoins', formData.fancoins);
    ApiFormData.append('file', formData.image);
    ApiFormData.append('activated', true);
    ApiFormData.append('is_collectible', true);
    ApiFormData.append('is_rare', formData.is_rare);
    ApiFormData.append('is_core', formData.is_core);
    ApiFormData.append('type', formData.is_core ? 'core' : 'rare');
    addReward(ApiFormData);
  };

  const headerContent = (
    <>
      <button className="backButton me-3" onClick={() => navigate("/")}>
        <ArrowLeft size={25} />
      </button>
      <p className="mb-0 fanstore-text">Add Reward</p>
    </>
  );

  const bodyContent = (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3 position-relative">
        <Form.Label className={`form-label pe-none transition-all ${focusedFields.title || formData.title
          ? "position-absolute top-0 start-0 translate-middle-y ms-3 bg-white px-2"
          : "position-absolute top-0 start-0 ms-3 bg-white px-2 translate-y-n10"
          }`}>Title</Form.Label>
        <Form.Control
          type="text"
          // placeholder="Title"
          name="title"
          value={formData.title}
          onChange={handleInputChange}
          className="formControl z-10"
          onFocus={() => setFocusedFields(prev => ({ ...prev, title: true }))}
          onBlur={() => setFocusedFields(prev => ({ ...prev, title: false }))}
        />
      </Form.Group>
      {!formData.is_core && (
        <Form.Group className="mb-3 position-relative">
          <Form.Label className={`form-label pe-none transition-all ${focusedFields.quantity || formData.quantity
            ? "position-absolute top-0 start-0 translate-middle-y ms-3 bg-white px-2"
            : "position-absolute top-0 start-0 ms-3 bg-white px-2 translate-y-n10"
            }`}>Quantity</Form.Label>
          <Form.Control
            type="number"
            min={1}
            // placeholder="Quantity"
            name="quantity"
            value={formData.quantity}
            onChange={handleInputChange}
            className="formControl"
            onFocus={() => setFocusedFields(prev => ({ ...prev, quantity: true }))}
            onBlur={() => setFocusedFields(prev => ({ ...prev, quantity: false }))}
          />
        </Form.Group>
      )}
      <Form.Group className="mb-3 position-relative">
        <Form.Label className={`form-label pe-none transition-all ${focusedFields.fancoins || formData.fancoins
          ? "position-absolute top-0 start-0 translate-middle-y ms-3 bg-white px-2"
          : "position-absolute top-0 start-0 ms-3 bg-white px-2 translate-y-n10"
          }`}>Fancoins</Form.Label>
        <Form.Control
          type="number"
          min={1}
          // placeholder="Fancoins"
          name="fancoins"
          value={formData.fancoins}
          onChange={handleInputChange}
          className="formControl"
          onFocus={() => setFocusedFields(prev => ({ ...prev, fancoins: true }))}
          onBlur={() => setFocusedFields(prev => ({ ...prev, fancoins: false }))}
        />
      </Form.Group>
      <div className="mb-4 d-flex align-items-center justify-content-between">
        <input
          type="file"
          id="imageUpload"
          onChange={handleImageUpload}
          style={{ display: 'none' }}
          accept="image/*"
        />
        <Button
          as="label"
          htmlFor="imageUpload"
          className="btnUpload"
          onClick={() => setFormData({ ...formData, image: null })}
        >
          {formData.image ? <X size={25} /> : <Plus size={25} />} Upload image
        </Button>
        <p className="mb-0 ellipsis">
          {formData.image && formData.image.name}
        </p>
      </div>
      <div className="mb-3 d-flex align-items-center justify-content-between">
        <label htmlFor="is_rare" className='fw-600'>Rare Collectible</label>
        <label className="switch">
          <input name="is_rare" type="checkbox" id="is_rare" checked={formData.is_rare} onChange={handleSwitchChange} />
          <span className="slider"></span>
        </label>
      </div>
      <div className="mb-3 d-flex align-items-center justify-content-between">
        <label htmlFor="is_core" className='fw-600'>Core Collectible</label>
        <label className="switch">
          <input name="is_core" type="checkbox" id="is_core" checked={formData.is_core} onChange={handleSwitchChange} />
          <span className="slider"></span>
        </label>
      </div>
      <div>
        <Button
          type="submit"
          className="btnActivate"
          disabled={!formData.title || (!formData.is_core && !formData.quantity) || !formData.fancoins || !formData.image}
        >
          Activate
        </Button>
      </div>
    </Form>
  );

  return (
    <>
      <ToastContainer />
      {loading ? <Loader loading={loading} /> :
        <Container>
          <Row>
            <Col>
              <CardTemplate headerContent={headerContent} bodyContent={bodyContent} />
            </Col>
          </Row>
        </Container>
      }
    </>
  );
}

export default AddRewardPage;
